import { useState } from "react";
import { MapPin, Search, LocateFixed, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { getPosition } from "@/lib/time";

export function CitySearch({ initial = "", onSearch, size = "lg", loading }) {
  const [city, setCity] = useState(initial);
  const big = size === "lg";
  const [locating, setLocating] = useState(false);

  const nearMe = async () => {
    setLocating(true);
    try {
      const pos = await getPosition();
      const { data } = await api.get("/geo/reverse", { params: pos });
      setCity(data.city);
      onSearch(data.city, pos);
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setLocating(false); }
  };

  const submit = (e) => {
    e.preventDefault();
    if (city.trim().length >= 2) onSearch(city.trim());
  };

  return (
    <form onSubmit={submit} data-testid="city-search-form"
      className={`flex items-center gap-2 bg-[#151C2C]/90 backdrop-blur-xl border border-[#26334D] focus-within:border-[#FF3B6B] transition-colors rounded-full ${big ? "p-2 pl-5" : "p-1.5 pl-4"}`}>
      <MapPin className={`${big ? "h-5 w-5" : "h-4 w-4"} text-[#FF3B6B] shrink-0`} />
      <input
        data-testid="city-search-input"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        placeholder="Type a city, state or country — e.g. Orlando, FL"
        className={`flex-1 min-w-0 bg-transparent outline-none placeholder:text-slate-500 ${big ? "text-base sm:text-lg py-2" : "text-sm py-1"}`}
      />
      <button type="button" data-testid="city-search-near-me" onClick={nearMe} disabled={locating} title="Find fun near me"
        className={`shrink-0 flex items-center gap-1.5 rounded-full text-[#00E5A3] hover:bg-[#00E5A3]/10 transition-colors ${big ? "h-12 px-4 text-sm" : "h-9 px-3 text-xs"}`}>
        {locating ? <Loader2 className="h-4 w-4 animate-spin" /> : <LocateFixed className="h-4 w-4" />}
        <span className="hidden md:inline font-semibold">Near me</span>
      </button>
      <Button data-testid="city-search-submit" type="submit" disabled={loading}
        className={`rounded-full bg-[#FF3B6B] hover:bg-[#E02E5A] text-white font-semibold ${big ? "h-12 px-6" : "h-9 px-4"}`}>
        <Search className="h-4 w-4 sm:mr-2" />
        <span className="hidden sm:inline">Find fun</span>
      </Button>
    </form>
  );
}
